export default __webpack_public_path__ + "static/media/provisional_landing_image.9dd75ea0.png";